import * as React from 'react'

import { EmployeeTimeoffPoliciesFromLeavesQuery } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import createDateObjects from 'modules/timeoff/lib/createDateObjects'

import Day from './_Day'
import './index.styles.css'
import { MunchedTree } from './store'

const FIRST_DAY_OF_THE_MONTH = 1

interface Props {
  dateTree: MunchedTree
  year: number
  month: number
  monthName: string
  employeeTimeoffPoliciesFromLeavesData: EmployeeTimeoffPoliciesFromLeavesQuery | null
}

const Month = ({
  dateTree,
  year,
  monthName,
  month,
  employeeTimeoffPoliciesFromLeavesData,
}: Props) => {
  const day = FIRST_DAY_OF_THE_MONTH
  const date = moment([year, month, day])
  const dateObjects = createDateObjects(date)

  const daysInitials = []

  for (let i = 0; i < 7; i++) {
    const dayOfWeek = moment().weekday(i).format('dd')
    daysInitials.push(
      <span key={`days_initials_${i}`} className={'Months_daysInitials'}>
        {dayOfWeek}
      </span>
    )
  }

  return (
    <li className={'Months_month'}>
      <div className={'Months_title'}>{monthName}</div>
      <div className={'Months_title'}>{daysInitials.concat()}</div>
      <div className={'Months_grid'}>
        {dateObjects.map((dateObject, i) => (
          <Day
            dateTree={dateTree}
            dateObject={dateObject}
            key={`day_${i}`}
            employeeTimeoffPoliciesFromLeavesData={employeeTimeoffPoliciesFromLeavesData}
          />
        ))}
      </div>
    </li>
  )
}

export default observer(Month)
